import { NewLog } from '../../../models/logs/NewLog';
import { ReceivingLogRow } from '../../../models/logs/ReceivingLogRow';
import { getNextBusinessDayString } from '../../../utils/date-functions';

/**
 * Submission context that isn't part of the form data itself.
 */
export interface LogRowContext {
  /** Label of the user-selected storage location (e.g. "Norfolk"). */
  locationLabel: string;
  /** Name of the user submitting the log. */
  loggedBy: string;
}

/**
 * Maps a NewLog (form values) to a ReceivingLogRow for submission.
 *
 * @param log - The log data captured from the form.
 * @param ctx - Location and user context for the submission.
 * @returns A new ReceivingLogRow object.
 */
export function createReceivingLogRow(log: NewLog, ctx: LogRowContext): ReceivingLogRow {
  return new ReceivingLogRow({
    vendor: log.vendor || '',
    jobNumber: log.jobNumber || '',
    jobName: log.jobName || '',
    jcDept: log.jcDept || '',
    poNumber: log.poNumber ? log.poNumber : '',
    items: log.items || '',
    email: log.contact || '',
    quantity: log.qtyUnits || '',
    location: log.shelfLocation || '',
    dateIn: log.dateIn || '',
    shopFloorSF: log.shopSqFt || 0,
    shipmentType: ctx.locationLabel || '',
    loggedBy: ctx.loggedBy || '',
    checkedOut: false,
    notes: log.notes || '',
    storageFacility: ctx.locationLabel || '',
    takenBy: '',
  });
}

/**
 * Applies the Service-log submission rules to a log row: Service items are
 * considered taken to their shelf/zone the next business day.
 *
 * @param row - The log row to mutate.
 * @param shelfLocation - The shelf/zone location the item is taken to.
 */
export function applyServiceSubmissionFields(row: ReceivingLogRow, shelfLocation: string): void {
  row.dateOut = getNextBusinessDayString();
  row.takenBy = 'Taken by ' + shelfLocation;
}
